const ENDPOINTS = {
		
	GET_CADENAS: () => 
		'/api/v1/cadenas',
		
	GET_CADENAS_BY_PARAMS: (nombre, activo) => {
		let url = '/api/v1/cadenas/' +
		'?estado=' + activo +
		'&nombre:ct=' + nombre;
			
		return url;
	},
	
	POST_CADENA: () =>
		'/api/v1/cadenas',
	
	ACTUALIZAR_CADENA: (id) => 
		'/api/v1/cadenas/' + id
};

export default ENDPOINTS;